export const MODAL_TYPES = {
    CREATE_FOLDER: 'CREATE_FOLDER',
    REMOVE_FOLDER: 'REMOVE_FOLDER',
    UPLOAD_AUDIO: 'UPLOAD_AUDIO',
    EDIT_AUDIO: 'EDIT_AUDIO',
    EDIT_FOLDER_NAME: 'EDIT_FOLDER_NAME',
    REMOVE_AUDIO: 'REMOVE_AUDIO',
}
